import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { showError, showSuccess } from "ReduxErrorBar";
import { Row, Col, Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import _ from "lodash";
import reactCSS from "reactcss";
import { ChromePicker, SketchPicker } from "react-color";

// constants
import { BaseComponent } from "BaseComponent";
import { COMMON_FAIL_MESSAGE, DOMAIN_NAME } from "Constants";
import LocaleStrings from "Languages";
import GoogleFontsList from "GoogleFontsList";

// actions
import { fetchEventDetails } from "DashboardUserAction";
import { openIntegrationModal, updateUserEventEmbedJson } from "SettingActions";

// components
import ApiDocs from "./api-doc";
import Ticket from "./ticket";
import Abstract from "./abstract";
import LivePoll from "./live-poll";
import RegForm from "./reg-form";
import CopyVisit from "CopyVisit";

class IntegrationDetails extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      validated: false,
      eventSettinigs_id: null,
      widgetData: null,
      saved_widgetData: null,

      // embedWidget states
      urlOptions: "false",
      embedOption: "",
      header: false,
      sessioncolor_allowed: false, // if schedule allowed then this determines if session colors will show
      isBG_added: false, // flag to determine if bg color is added or not
      bgColor: "ffffff",
      isFont_color_added: false, // flage to determine id font color is added or not
      fontColor: "18203a",
      isFont_added: false, // flage to determine id font family is added or not
      font: "Poppins",

      // Sketch picker
      displayBGColorPicker: false,
      displayFontColorPicker: false,
    };
  }

  componentDidMount() {
    this.props.fetchEventDetails(this.props.session, (res) => {
      if (res.success && res.resource.eventsettings_by_eventid) {
        let saved_widgetData = _.isEmpty(
          res.resource.eventsettings_by_eventid[0].widget_json
        )
          ? null
          : JSON.parse(res.resource.eventsettings_by_eventid[0].widget_json);

        this.setState({
          eventSettinigs_id: res.resource.eventsettings_by_eventid[0].id,
          urlOptions: _.isEmpty(saved_widgetData)
            ? "false"
            : saved_widgetData.redirection, // all or selective, if false then url will not generate
          embedOption: "", // link or iframe
          header: _.isEmpty(saved_widgetData)
            ? false
            : !saved_widgetData.header,
          sessioncolor_allowed: _.isEmpty(saved_widgetData)
            ? false
            : saved_widgetData.sessioncolor, // if schedule allowed then this determines if session colors will show
          isBG_added: _.isEmpty(saved_widgetData) ? false : true, // flag to determine if bg color is added or not
          bgColor: _.isEmpty(saved_widgetData)
            ? "ffffff"
            : saved_widgetData.bgcolor,
          isFont_color_added: _.isEmpty(saved_widgetData) ? false : true, // flage to determine id font color is added or not
          fontColor: _.isEmpty(saved_widgetData)
            ? "18203a"
            : saved_widgetData.fontcolor,
          isFont_added: _.isEmpty(saved_widgetData) ? false : true, // flage to determine id font family is added or not
          font: _.isEmpty(saved_widgetData)
            ? "Poppins"
            : _.split(saved_widgetData.font, "+").join(" "),
        });
      }
    });
  }

  close() {
    this.props.openIntegrationModal({ showModal: false });
    this.setState({ embedOption: "" });
  }

  handleSketchPickerPopper = (name, type) => {
    if (name == "bg") {
      if (type == "close") this.setState({ displayBGColorPicker: false });
      else
        this.setState({
          displayBGColorPicker: !this.state.displayBGColorPicker,
        });
    } else {
      if (type == "close") this.setState({ displayFontColorPicker: false });
      else
        this.setState({
          displayFontColorPicker: !this.state.displayFontColorPicker,
        });
    }
  };

  onSubmitForm = (value) => {
    let urlOptions = "false";
    if (value.all === true) urlOptions = "all";
    else {
      urlOptions = "";
      if (value.schedule === true) urlOptions += "1";
      if (value.speaker === true) urlOptions += "2";
      if (value.sponsor === true) urlOptions += "3";
    }

    let updateJson_value = {
      redirection: urlOptions, // false, 1-3, 12-23-13, all
      header: !value.header, // as hide is considered, NOT result is collected
      sessioncolor: value.sessioncolor_allowed,
      bgcolor: _.replace(value.bgcolor_picker, "#", ""),
      font: _.split(value.font_family, " ").join("+"),
      fontcolor: _.replace(value.fontcolor_picker, "#", ""),
    };

    // Modal close
    this.close();

    // Saving widget settings
    this.props.updateUserEventEmbedJson(
      this.props.session,
      this.state.eventSettinigs_id,
      updateJson_value,
      (res) => {}
    );
  };

  // ====== This codes are uplifted from child commponent embedWidget and for that purpose only
  handleWidgetJsonUpdate = () => {
    if (this.state.embedOption !== "") {
      let updateJson_value = {
        redirection: this.state.urlOptions, // false, 1-3, 12-23-13, all
        header: !this.state.header, // as hide is considered, NOT result is collected
        sessioncolor: this.state.sessioncolor_allowed,
        bgcolor: this.state.bgColor,
        font: this.state.font,
        fontcolor: this.state.fontColor,
      };

      this.props.updateJson(updateJson_value);
    }
  };

  handleURLUpdate = (e) => {
    let isChecked = e.target.checked, // filed is checked or not
      fieldName = e.target.name; // field name

    if (fieldName == "all") {
      if (isChecked) {
        this.setState({ urlOptions: "all" });

        // --- checkbox
        this.props.autofill("schedule", true);
        this.props.autofill("speaker", true);
        this.props.autofill("sponsor", true);
      } else {
        this.setState({ urlOptions: "false" });

        // --- checkbox
        this.props.autofill("schedule", false);
        this.props.autofill("speaker", false);
        this.props.autofill("sponsor", false);
      }
    } else {
      this.props.autofill("all", false);

      let local_urlOptions =
        this.state.urlOptions == "all"
          ? "123"
          : this.state.urlOptions == "false"
          ? ""
          : this.state.urlOptions;

      if (fieldName == "schedule") {
        if (isChecked)
          local_urlOptions += "1"; // if checked option added w/o order
        else local_urlOptions = local_urlOptions.replace(/1/g, ""); // else replaced from the string
      } else if (fieldName == "speaker") {
        if (isChecked) local_urlOptions += "2";
        else local_urlOptions = local_urlOptions.replace(/2/g, "");
      } else if (fieldName == "sponsor") {
        if (isChecked) local_urlOptions += "3";
        else local_urlOptions = local_urlOptions.replace(/3/g, "");
      }

      if (local_urlOptions == "") {
        this.setState({ urlOptions: "false" }); // to maintain state format
      } else {
        local_urlOptions = local_urlOptions.split("").sort().join(""); // will convert 213 into 123 order

        if (local_urlOptions == "123") {
          this.setState({ urlOptions: "all" });

          this.props.autofill("all", true);
        } else {
          this.setState({ urlOptions: local_urlOptions });
        }
      }
    }
  };

  handleEmbedType = (e) => {
    let isChecked = e.target.checked,
      fieldName = e.target.name;

    let local_embedOption = this.state.embedOption;

    if (fieldName == "link") {
      if (isChecked) {
        if (local_embedOption == "iframe") local_embedOption = "both";
        else local_embedOption = fieldName;
      } else if (local_embedOption == "both") local_embedOption = "iframe";
      else local_embedOption = "";
    } else {
      if (isChecked) {
        if (local_embedOption == "link") local_embedOption = "both";
        else local_embedOption = fieldName;
      } else if (local_embedOption == "both") local_embedOption = "link";
      else local_embedOption = "";
    }

    this.setState({ embedOption: local_embedOption });
  };

  handleHideHeader = (e) => {
    this.setState({ header: e.target.checked });
  };

  handleShowSessionColor = (e) => {
    this.setState({
      sessioncolor_allowed: e.target.checked,
    });
  };

  handleColorPicker = (color, name) => {
    let fieldName = name;

    switch (fieldName) {
      case "bgcolor_picker":
        this.setState({
          isBG_added: true,
          bgColor: _.replace(color.hex, "#", ""),
        });
        break;

      case "fontcolor_picker":
        this.setState({
          isFont_color_added: true,
          fontColor: _.replace(color.hex, "#", ""),
        });
        break;

      default:
        break;
    }
  };

  handleFontFamily = (e) => {
    let inputValue = e.target.value;

    // space replaced from url
    inputValue = _.split(inputValue, " ").join("+");

    this.setState({ isFont_added: true, font: inputValue });
  };

  embedWidgetSettings = (settingsJson) => {
    if (!_.isEmpty(settingsJson)) this.setState({ widgetData: settingsJson });
  };
  // ====== embedWidget codes ends

  render() {
    const { eventDetails, integrationModalReducer, handleSubmit } = this.props;
    const {
      header,
      sessioncolor_allowed,
      isBG_added,
      bgColor,
      isFont_added,
      font,
      isFont_color_added,
      fontColor,
    } = this.state;

    // ====== for embedWidget case STARTS
    const seoCode =
      eventDetails && eventDetails.seocode ? eventDetails.seocode : "";

    let ticketUrl = `https://${seoCode}.${DOMAIN_NAME}/widget/`;

    // --- Redirection as defined in widget document
    let showLinkIframe = false;
    if (
      this.state.urlOptions == "all" ||
      this.state.urlOptions == "12" ||
      this.state.urlOptions == "13" ||
      this.state.urlOptions == "1"
    ) {
      ticketUrl += `sessions`;
      showLinkIframe = true;
    } else if (this.state.urlOptions == "23" || this.state.urlOptions == "2") {
      ticketUrl += "speakers";
      showLinkIframe = true;
    } else if (this.state.urlOptions == "3") {
      ticketUrl += "sponsors";
      showLinkIframe = true;
    } else showLinkIframe = false;

    ticketUrl += `?redirection=${
      this.state.urlOptions.length == 1 ? "false" : this.state.urlOptions
    }`;

    // --- Features
    // common arr
    let featuresArr = [];
    // elemnt pushed
    if (header) featuresArr.push("header=false");
    if (sessioncolor_allowed) featuresArr.push("sessioncolor=true");
    if (isBG_added) featuresArr.push(`bgcolor=0x${bgColor}`);
    if (isFont_added && font !== "") featuresArr.push(`font=${font}`);
    if (isFont_color_added) featuresArr.push(`fontcolor=0x${fontColor}`);
    // appneding after imploding with &
    if (featuresArr.length > 0) ticketUrl += "&" + _.join(featuresArr, "&");

    // --- Creating iFrame url
    let iframeUrl = `<iframe src="${ticketUrl}" title="Event Schedules"></iframe>`;
    // ====== for embedWidget case ENDS

    // ----- Sketch picker style var
    let styles = reactCSS({
      default: {
        bg_color: {
          width: "36px",
          height: "14px",
          borderRadius: "2px",
          background: `#${this.state.bgColor}`,
        },
        font_color: {
          width: "36px",
          height: "14px",
          borderRadius: "2px",
          background: `#${this.state.fontColor}`,
        },
        swatch: {
          padding: "5px",
          background: "#fff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer",
        },
        popover: {
          position: "absolute",
          zIndex: "2",
          top: "calc(30%)",
          right: 160,
        },
        cover: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px",
        },
      },
    });

    return (
      <div>
        <Modal
          className={`modal-container ${
            integrationModalReducer && integrationModalReducer.key == "api"
              ? "custom-full-screen-modal"
              : ""
          }`}
          show={
            integrationModalReducer &&
            integrationModalReducer.showModal === true
              ? true
              : false
          }
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          dialogClassName={
            integrationModalReducer && integrationModalReducer.key == "api"
              ? "modal-xl"
              : "modal-md"
          }
        >
          <form onSubmit={handleSubmit(this.onSubmitForm)}>
            <Modal.Header>
              <div className="import-modal-title">
                {integrationModalReducer && integrationModalReducer.modalTitle
                  ? integrationModalReducer.modalTitle
                  : ""}
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.close()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                  alt="close the edit modal"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              <>
                {integrationModalReducer &&
                integrationModalReducer.key == "api" ? (
                  <ApiDocs />
                ) : integrationModalReducer &&
                  integrationModalReducer.key == "ticket" ? (
                  <Ticket />
                ) : integrationModalReducer &&
                  integrationModalReducer.key == "form" ? (
                  <RegForm />
                ) : integrationModalReducer &&
                  integrationModalReducer.key == "live" ? (
                  <LivePoll />
                ) : integrationModalReducer &&
                  integrationModalReducer.key == "abstract" ? (
                  <Abstract />
                ) : integrationModalReducer &&
                  integrationModalReducer.key == "widget" ? (
                  <>
                    {/* <EmbedWidget
                      autofill={this.props.autofill}
                      savedJson={this.state.saved_widgetData}
                      updateJson={this.embedWidgetSettings}
                    /> */}

                    <div className="row ticket-dashboard scrollable-content">
                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        {/* ----- Feature choose section ----- */}
                        <div className="form-group">
                          {/* --- How to embed, link/iFrame --- */}
                          <div className="row mt-2">
                            <div className="col-12">
                              <label className="control-label-top ">
                                {LocaleStrings.integration_embed_how_to_embed}
                              </label>
                              <div
                                className=""
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 8,
                                }}
                              >
                                <Field
                                  name={"link"}
                                  label={
                                    LocaleStrings.integration_embed_opt_url
                                  }
                                  type="checkbox"
                                  component={this.renderFieldCheckbox}
                                  onChange={this.handleEmbedType}
                                />
                                <Field
                                  name={"iframe"}
                                  label={
                                    LocaleStrings.integration_embed_opt_iframe
                                  }
                                  type="checkbox"
                                  component={this.renderFieldCheckbox}
                                  onChange={this.handleEmbedType}
                                />
                              </div>
                            </div>
                          </div>

                          {/* --- What to embed (schedule, speaker, sponsor, all) ---  */}
                          <div className="row">
                            <div className="col-12">
                              <label className="control-label-top ">
                                {LocaleStrings.integration_embed_what_to_embed}
                              </label>
                              <div
                                className=""
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: 8,
                                }}
                              >
                                <Field
                                  name={"schedule"}
                                  label={
                                    LocaleStrings.integration_embed_opt_schedule
                                  }
                                  type="checkbox"
                                  component={this.renderFieldCheckbox}
                                  onChange={this.handleURLUpdate}
                                />
                                <Field
                                  name={"speaker"}
                                  label={
                                    LocaleStrings.integration_embed_opt_speaker
                                  }
                                  type="checkbox"
                                  component={this.renderFieldCheckbox}
                                  onChange={this.handleURLUpdate}
                                />
                                <Field
                                  name={"sponsor"}
                                  label={
                                    LocaleStrings.integration_embed_opt_sponsor
                                  }
                                  type="checkbox"
                                  component={this.renderFieldCheckbox}
                                  onChange={this.handleURLUpdate}
                                />
                                <Field
                                  name={"all"}
                                  label={
                                    LocaleStrings.integration_embed_opt_all
                                  }
                                  type="checkbox"
                                  component={this.renderFieldCheckbox}
                                  onChange={this.handleURLUpdate}
                                />
                              </div>
                            </div>
                          </div>

                          {/* --- Hide header --- */}
                          <div className="row mt-2">
                            <div className="col-12">
                              <label className="control-label-top ">
                                {
                                  LocaleStrings.integration_embed_hide_header_label
                                }
                              </label>
                              <Field
                                name={"hide_header"}
                                label={
                                  LocaleStrings.integration_embed_hide_header
                                }
                                type="checkbox"
                                component={this.renderFieldCheckbox}
                                onChange={this.handleHideHeader}
                              />
                            </div>
                          </div>

                          {/* --- Hide session color --- */}
                          <div
                            className="row mt-2"
                            style={
                              this.state.urlOptions == "all" ||
                              this.state.urlOptions.includes("1")
                                ? {}
                                : { opacity: 0.3, cursor: "not-allowed" }
                            }
                          >
                            <div className="col-12">
                              <label className="control-label-top ">
                                {
                                  LocaleStrings.integration_embed_add_sessioncolor_label
                                }
                              </label>
                              <Field
                                name={"sessioncolor_allowed"}
                                label={
                                  LocaleStrings.integration_embed_add_sessioncolor
                                }
                                type="checkbox"
                                component={this.renderFieldCheckbox}
                                onChange={(e) =>
                                  this.state.urlOptions == "all" ||
                                  this.state.urlOptions.includes("1")
                                    ? this.handleShowSessionColor(e)
                                    : null
                                }
                              />
                            </div>
                          </div>

                          {/* --- BG color --- */}
                          <div className="row mt-2">
                            <label className="control-label-top ">
                              {LocaleStrings.integration_embed_choose_bg_label}
                            </label>
                            <div className="col-4 pr-0" style={{ height: 30 }}>
                              <div style={{ display: "flex", gap: 8 }}>
                                <div
                                  style={styles.swatch}
                                  onClick={() =>
                                    this.handleSketchPickerPopper("bg", "open")
                                  }
                                >
                                  <div style={styles.bg_color} />
                                </div>
                                {this.state.displayBGColorPicker ? (
                                  <div style={styles.popover}>
                                    <div
                                      style={styles.cover}
                                      onClick={() =>
                                        this.handleSketchPickerPopper(
                                          "bg",
                                          "close"
                                        )
                                      }
                                    />
                                    <ChromePicker
                                      color={this.state.bgColor}
                                      onChange={(color) =>
                                        this.handleColorPicker(
                                          color,
                                          "bgcolor_picker"
                                        )
                                      }
                                    />
                                  </div>
                                ) : null}
                                <span className="custom-text1-secondary-normal">
                                  {LocaleStrings.integration_embed_use_picker}
                                </span>
                              </div>
                            </div>
                            <div
                              className="col-8 px-0 reset_color_simple_colorpicker"
                              onClick={() =>
                                this.setState({
                                  isBG_added: false,
                                  bgColor: "ffffff",
                                })
                              }
                            >
                              {LocaleStrings.reset}
                            </div>
                          </div>

                          {/* --- Font family --- */}
                          <div className="row mt-2">
                            <label className="control-label-top ">
                              {
                                LocaleStrings.integration_embed_choose_font_label
                              }
                            </label>
                            <div className="col-6 pr-0">
                              <Field
                                name={"font_family"}
                                component={this.renderSelect}
                                opts={GoogleFontsList}
                                onChange={this.handleFontFamily}
                              />
                            </div>
                          </div>

                          {/* --- Font color --- */}
                          <div className="row mt-2">
                            <label className="control-label-top ">
                              {
                                LocaleStrings.integration_embed_choose_fontcolor_label
                              }
                            </label>
                            <div className="col-4 pr-0" style={{ height: 30 }}>
                              <div style={{ display: "flex", gap: 8 }}>
                                <div
                                  style={styles.swatch}
                                  onClick={() =>
                                    this.handleSketchPickerPopper(
                                      "font",
                                      "open"
                                    )
                                  }
                                >
                                  <div style={styles.font_color} />
                                </div>
                                {this.state.displayFontColorPicker ? (
                                  <div
                                    style={{
                                      ...styles.popover,
                                      top: "calc(60%)",
                                    }}
                                  >
                                    <div
                                      style={styles.cover}
                                      onClick={() =>
                                        this.handleSketchPickerPopper(
                                          "font",
                                          "close"
                                        )
                                      }
                                    />
                                    <ChromePicker
                                      color={this.state.fontColor}
                                      onChange={(color) =>
                                        this.handleColorPicker(
                                          color,
                                          "fontcolor_picker"
                                        )
                                      }
                                    />
                                  </div>
                                ) : null}
                                <span className="custom-text1-secondary-normmal">
                                  {LocaleStrings.integration_embed_use_picker}
                                </span>
                              </div>
                            </div>
                            <div
                              className="col-8 px-0 reset_color_simple_colorpicker"
                              onClick={() =>
                                this.setState({
                                  isFont_color_added: false,
                                  fontColor: "18203a",
                                })
                              }
                            >
                              {LocaleStrings.reset}
                            </div>
                          </div>
                        </div>

                        {/* ----- URL/iFrame create section ----- */}
                        {!_.isEmpty(seoCode) &&
                        showLinkIframe &&
                        this.state.embedOption !== "" ? (
                          <div style={{ marginBottom: 20 }}>
                            {/* --- Caustion text --- */}
                            <div
                              className="control-label-top"
                              style={{ marginBottom: 8 }}
                            >
                              {LocaleStrings.integration_caution_text}
                            </div>

                            {/* --- Link --- */}
                            {this.state.embedOption == "link" ||
                            this.state.embedOption == "both" ? (
                              <>
                                <CopyVisit
                                  elementId={"link-copy"}
                                  title={
                                    LocaleStrings.integration_ticket_link_address
                                  }
                                  subtitle={
                                    LocaleStrings.integration_ticket_link_address_text
                                  }
                                  link={ticketUrl}
                                  readonly
                                />
                              </>
                            ) : (
                              ""
                            )}

                            {/* --- iFrame --- */}
                            {this.state.embedOption == "iframe" ||
                            this.state.embedOption == "both" ? (
                              <>
                                <CopyVisit
                                  elementId={"iframe-copy"}
                                  title={LocaleStrings.integration_ticket_embed}
                                  subtitle={
                                    LocaleStrings.integration_ticket_embed_text
                                  }
                                  embed
                                  link={iframeUrl}
                                  readonly
                                />
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-custom-white"
                type={
                  integrationModalReducer.key == "widget" ? "submit" : "button"
                }
                onClick={(e) =>
                  integrationModalReducer.key == "widget" ? null : this.close()
                }
              >
                {integrationModalReducer.key == "widget"
                  ? LocaleStrings.button_close_and_save
                  : LocaleStrings.button_close}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  return errors;
}

function mapStateToProps(state) {
  let initialValue = {},
    eventDetails = state.userEventDetails,
    savedJson = !_.isEmpty(eventDetails.eventsettings_by_eventid)
      ? JSON.parse(eventDetails.eventsettings_by_eventid[0].widget_json)
      : null;

  if (!_.isEmpty(savedJson)) {
    let prevRedirectionVal = savedJson.redirection;
    if (prevRedirectionVal == "all") {
      initialValue.all = true;
      initialValue.schedule = true;
      initialValue.speaker = true;
      initialValue.sponsor = true;
    } else {
      initialValue.all = false;
      if (_.includes(prevRedirectionVal, "1")) initialValue.schedule = true;
      if (_.includes(prevRedirectionVal, "2")) initialValue.speaker = true;
      if (_.includes(prevRedirectionVal, "3")) initialValue.sponsor = true;
    }

    initialValue.hide_header = !savedJson.header;
    initialValue.sessioncolor_allowed = savedJson.sessioncolor;
    initialValue.bgcolor_picker = savedJson.bgcolor;
    initialValue.font_family = savedJson.font;
    initialValue.fontcolor_picker = savedJson.fontcolor;
  } else {
    initialValue.all = false;
    initialValue.schedule = false;
    initialValue.speaker = false;
    initialValue.sponsor = false;
    initialValue.hide_header = false;
    initialValue.sessioncolor_allowed = false;
    initialValue.bgcolor_picker = "ffffff";
    initialValue.font_family = "Poppins";
    initialValue.fontcolor_picker = "18203a";
  }

  return {
    session: state.session,
    user: state.user,
    deviceSize: state.deviceSize,
    integrationModalReducer: state.integrationModalReducer,

    eventDetails,
    initialValues: initialValue,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openIntegrationModal,
  updateUserEventEmbedJson,
  fetchEventDetails,
})(
  reduxForm({
    form: "LanguageAddForm",
    validate,
    /*asyncValidate,
        asyncBlurFields:['oldpwd'],*/
    enableReinitialize: true,
  })(IntegrationDetails)
);
